



















































import { Component, Mixins } from "vue-property-decorator";
import PlaceholderCard from "@/components/cards/PlaceholderCard.vue";
import ServicePreviewCard from "@/components/cards/ServicePreviewCard.vue";
import ButtonCommon from "@/components/lib/ButtonCommon.vue";
import fetchServiceTypeMixin from "@/mixins/fetchServiceTypeMixin";
import {
  IServiceType,
  IServiceTypeData,
  ServiceChoice,
  ServiceType,
} from "@/entities";

@Component({
  components: {
    ServicePreviewCard,
    PlaceholderCard,
    ButtonCommon,
  },
})
export default class ServicesPreviewSection extends Mixins(
  fetchServiceTypeMixin
) {
  protected fetching: boolean = false;
  protected services: IServiceType[] = [];

  // get planServices(): IServiceType[] {
  //   return [
  //     {
  //       name: this.$options.filters?.capitalize(this.$t('home.services.items.plan-public.name')),
  //       description: this.$options.filters?.capitalize(this.$t('home.services.items.plan-public.description')),
  //       type: 'plan-public' as ServiceChoice
  //     }
  //   ].map((planService: IServiceTypeData) => new ServiceType(planService));
  // }

  get validServices(): IServiceType[] {
    return this.services.filter((type: IServiceType) => type.validate());
  }

  get servicesToShow(): IServiceType[] {
    return [...this.validServices];
  }

  get mayHaveItems(): boolean {
    return !!this.servicesToShow.length || this.fetching;
  }
}
